import React, { useState } from 'react'
import DataTable from './DataTable'
import { KTSVG } from '../../_metronic/helpers'
import PackingBomCreateModal from './PackingBomCreateModal'
import { Link } from 'react-router-dom'
import 'react-loading-skeleton/dist/skeleton.css'

const PackingBomList = () => {
	const [newData, setNewData] = useState<any>({})
	const [showPackingBomCreateModal, setShowPackingBomCreateModal] = useState(false)
	const [bomCreateProduct, setBomCreateProduct] = useState<any>(null)

	const reloadTable = () => setNewData({ id: Date.now() })

	const showBomCreator = (row: any) => {
		setBomCreateProduct({
			idProducts: row.idProducts,
			productName: row.productName,
		})
		setShowPackingBomCreateModal(true)
	}

	const handlePackingBomCreateClose = (saved?: boolean) => {
		setShowPackingBomCreateModal(false)
		setBomCreateProduct(null)
		if (saved) {
			reloadTable()
		}
	}

	const parseBomList = (bomList: string | null) => {
		if (!bomList) {
			return []
		}
		return bomList.split('|').map((entry) => {
			const [id, ...nameParts] = entry.split(':')
			return { id: Number(id), name: nameParts.join(':') }
		}).filter((bom) => bom.id && bom.name)
	}

	const columns = [
		{ value: 'id', title: 'Id', style: { textAlign: 'center' } },
		{ value: 'productName', title: 'Product Name', style: { textAlign: 'left' } },
		{ value: 'productCode', title: 'Code', style: { textAlign: 'left' } },
		{ value: 'packing', title: 'Packing', style: { textAlign: 'center' } },
		{ value: 'size', title: 'Size', style: { textAlign: 'center' } },
		{ value: 'unitName', title: 'Unit', style: { textAlign: 'left' } },
		{
			value: 'bomSetup',
			title: 'BOM',
			style: { textAlign: 'center', whiteSpace: 'nowrap' },
			hasActionsComponent: true,
			actionsComponent: (row: any) => {
				const boms = parseBomList(row.bomList)
				if (boms.length > 0) {
					return (
						<div>
							{boms.map((bom, bomIndex) => (
								<React.Fragment key={bom.id}>
									{bomIndex > 0 && <hr className="my-1" />}
									<Link to={`/packing-bom-formulation/${row.idProducts}?id_packing_bom=${bom.id}`}>
										{bom.name}
									</Link>
								</React.Fragment>
							))}
						</div>
					)
				}
				return (
					<button type="button" className="btn btn-warning btn-sm" onClick={() => showBomCreator(row)}>
						Create BOM
					</button>
				)
			},
		},
	]

	const filters = {
		id: { filterType: 'like', filterValue: '' },
		productName: { filterType: 'like', filterValue: '' },
		productCode: { filterType: 'like', filterValue: '' },
		packing: { filterType: 'like', filterValue: '' },
		size: { filterType: 'like', filterValue: '' },
		unitName: { filterType: 'like', filterValue: '' },
		bomSetup: { filterType: 'like', filterValue: '' },
	}

	const url = process.env.REACT_APP_API_URL + 'packing-bom-list'

	return (
		<>
			<div className="card card-custom">
				<div className="card-header">
					<div className="card-title">
						<KTSVG path="/media/svg/icons/Text/Bullet-list.svg" className="svg-icon-1 svg-icon-primary" />
						<span className="text fw-bolder" style={{ marginLeft: '10px' }}>
							Packing BOM
						</span>
					</div>
				</div>

				<div className="card-body">
					<DataTable
						url={url}
						columns={columns}
						filters={filters}
						newData={newData}
					/>
				</div>
			</div>

			<PackingBomCreateModal
				show={showPackingBomCreateModal}
				handleClose={handlePackingBomCreateClose}
				product={bomCreateProduct}
				defaultBomName="Default BOM"
			/>
		</>
	)
}

export default PackingBomList
